import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Stack, Typography } from "@mui/material";
import { TagMetaData } from "src/config/store/services/media-api/types";
import { TAG_COLORS } from "src/config/store/services/tags-api/types";
import { useIsMobileView } from "src/modules/shared/hooks/use-is-mobile-view";
import { TagIcon } from "../../tag-icon/tag-icon";
import { classes } from "./tag-popup.styles";

type TagPopupProps = {
  close: () => void;
  tag: TagMetaData;
};

const TagPopup: React.FC<TagPopupProps> = ({ close, tag }) => {
  const isMobile = useIsMobileView();

  if (!tag.data) {
    return null;
  }

  return (
    <Box
      sx={classes.tagPopup}
      style={{
        backgroundColor: TAG_COLORS[tag.data.color],
      }}
    >
      <Box>
        <TagIcon icon={tag.data.icon} color="black" size={isMobile ? 44 : 88} />
      </Box>

      <Box>
        <Box sx={classes.header}>
          <Box>
            <Typography
              sx={{
                textTransform: "capitalize",
              }}
              variant="caption"
            >
              {tag.data.icon}
            </Typography>
            <Typography sx={classes.title} variant="subtitle2">
              {tag.data.name}
            </Typography>
          </Box>
          <Box>
            <CloseIcon onClick={close} sx={classes.closeIcon} />
          </Box>
        </Box>

        <Box>{tag.data.info}</Box>

        <Box sx={classes.actions}>
          <Stack spacing={2} direction="row">
            {tag.data.secondaryButton?.title && (
              <Button
                variant="outlined"
                target="_blank"
                rel="noopener noreferrer"
                href={tag.data.secondaryButton.url}
              >
                {tag.data.secondaryButton.title}
              </Button>
            )}
            <Button
              variant="contained"
              target="_blank"
              rel="noopener noreferrer"
              href={tag.data.primaryButton.url}
            >
              {tag.data.primaryButton.title}
            </Button>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default TagPopup;
